import { images } from '_/assets';
import Button from '_/components/Button';
import Text from '_/components/Text';
import { colors, fontSizes, spacing } from '_/constants/theme';
import { AppRoute } from '_/navigation/types';
import { EventsResponse } from '_/services/models/events.model';
import { useNavigation, useRoute, RouteProp } from '@react-navigation/native';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Image, SafeAreaView, View } from 'react-native';
import { showMessage } from 'react-native-flash-message';
import styles from './styles';

interface ParamsProps {
  event: EventsResponse;
  blockEarlyCheckin?: boolean;
  maxEarlyCheckinOffset?: number;
}
//Mudar o nome do Componente
export default function CheckinSuccess() {
  const { t } = useTranslation();
  const navigation = useNavigation<any>();
  const route = useRoute<RouteProp<Record<string, ParamsProps>, string>>();
  const { event, blockEarlyCheckin, maxEarlyCheckinOffset } = route.params;

  useEffect(() => {
    if (blockEarlyCheckin) return;

    showMessage({
      type: 'success',
      message: t('success'),
      description: t('qrCodeScreen.successMessages.checkinSuccess'),
      backgroundColor: colors.successGreen,
    });
  }, [t, blockEarlyCheckin]);

  const title = blockEarlyCheckin
    ? t('readingQrCodeScreen.earlyCheckinBlockedTitle')
    : t('readingQrCodeScreen.successTitle');
  const description = blockEarlyCheckin
    ? t('readingQrCodeScreen.earlyCheckinBlockedDescription', { maxEarlyCheckinOffset })
    : t('readingQrCodeScreen.successMessage');
  const image = blockEarlyCheckin ? images.noContentGirl : images.checkinGuy;

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.content}>
        <Image source={image} style={styles.image} />
        <Text fontSize={fontSizes.lg} fontType="bold" style={styles.title} color={colors.darkGrey}>
          {title}
        </Text>
        <Text fontSize={fontSizes.md2} style={styles.message} color={colors.darkGrey}>
          {description}
        </Text>
        {event?.slot?.name ? (
          <Text
            fontSize={fontSizes.md2}
            fontType="bold"
            style={styles.slotName}
            color={colors.darkGrey}
          >
            {event.slot.name}
          </Text>
        ) : null}
      </View>
      <View style={styles.buttonContainer}>
        <Button
          backgroundColor={colors.successGreen}
          textColor={colors.white}
          onPress={() => navigation.navigate(AppRoute.HOME)}
        >
          {t('back')}
        </Button>
      </View>
    </SafeAreaView>
  );
}
